module.exports = __webpack_public_path__ + "img/Slide4.e6a58f87.jpg";